module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderDesktop/Overlay.module.scss");